<form [formGroup]="parentForm">
  <!-- Common Fields -->
  @if (commonFormSections?.length > 0) {
    <div class="common-form-container">
      @if (!hideOrderFormTitle) {
        <div class="common-form-header mat-mdc-card display">
          <span>
            {{ 'FRONTEND.STORE.ORDER_FORM.LABELS.COMMON_FORM_HEADER_TITLE' | translate }}
          </span>
          <span class="common-form-header-text">
            {{ 'FRONTEND.STORE.ORDER_FORM.LABELS.COMMON_FORM_HEADER_TEXT' | translate }}
          </span>
        </div>
      }
      @for (formSection of commonFormSections; track formSection) {
        <store-dropdown-form-section
          [parentForm]="parentForm"
          [prepopulatedData]="formSection.populatedData"
          [fields]="formSection.fields"
          [displayAutoTitle]="!orderFormOptions.readOnly"
          [titleText]="formSection.sectionName | translate"
          [startOpen]="dropdownOpen$ | async"
          [editingHint]="'FRONTEND.STORE.ORDER_FORM.LABELS.COMMON_FORM_EDITING_HINT' | translate"
        ></store-dropdown-form-section>
      }
      @if (extraFieldsSection) {
        <!-- For some unknown reason, the *ngFor is needed for form fields to be updatable after the order refreshes. -->
        <!-- DO NOT remove the *ngFor, it is needed to fix https://vendasta.jira.com/browse/QOF-2060. -->
        @for (extraSection of [extraFieldsSection]; track extraSection) {
          <store-dropdown-form-section
            [parentForm]="parentForm"
            [prepopulatedData]="extraSection.prepopulatedData"
            [fields]="extraSection.fields"
            [displayAutoTitle]="!orderFormOptions.readOnly"
            [displayAutoDescription]="false"
            [startOpen]="true"
            [titleText]="'FRONTEND.STORE.ADMINISTRATIVE_QUESTIONS' | translate"
          ></store-dropdown-form-section>
        }
      }
    </div>
  }

  <!--Custom Fields-->
  @if (customFormSections) {
    @if (customFormSections.length > 0) {
      <div class="custom-form-container">
        @for (sectionData of customFormSections; track sectionData) {
          <store-order-form-section
            [data]="sectionData"
            [extraHeaderContent]="extraHeaderContent"
            [bottomActionsContent]="bottomActionsContent"
          ></store-order-form-section>
        }
      </div>
    }
  }
</form>
